export default (payload) => ({
  type: 'CURRENT_PHONE',
  payload,
});
